// extracted by mini-css-extract-plugin
export default {"actionButton":"WisePdpActionButton_actionButton__2ZOlO","actionButtonPending":"WisePdpActionButton_actionButtonPending__nGK1i"};